import React, { useEffect } from 'react';
import { programasDIF } from '../../json/programasDIF';
import './estilos.css';

  const ProgramasDIF = () => {
        useEffect(() => {
          window.scrollTo(0, 0);
  },[]); 

  return (
    <div className="container">
        <div className="row">
              <div> 
                  <h3 className="title">Programas que opera el Sistema DIF Hidalgo</h3>
                  <hr className="hr-gob" />
              </div>

         <div style={{ width: "100%" }}>
            <table className="table table-striped table-bordered">
                      <tr>
                        <th scope="col" colspan="2"><div className="detalle_nombreLicitacion" style={{ width: "460px" }}>Programa</div></th>
                        <th scope="col"><div style={{ width: "150px" }}>Documento</div></th>
                      </tr>
            </table>
         </div>
            
            <div className="contenedor-divs">
                       {
                        programasDIF.map((item, index)=>(
                           <div key={ index }>
                               <div className="programasDIF_detalleAcuerdo"> { item.acuerdo } </div>
                                 { 
                                    item.documentos.map((doc, index)=>(
                                      <div key={ index } className="div-padre">
                                          <div className="detalle_i eleProgramas"><i className="bi bi-file-earmark-pdf-fill"></i></div>   
                                          <div  className="programasDIF_detallePrograma eleProgramas"> { doc.nombre } </div>
                                          <div key={ index } className="div-elementos eleProgramas">
                                              <a href={ doc.linkPDF } target="_blank" rel="noopener noreferrer"><button class="btn btn-default btn-pdf" type="button">PDF</button></a>
                                          </div>
                                      </div>    
                                    ))
                                  }
                            </div>
                        ))
                       }
          </div>
          <br />  
          <br />       
       </div>
    </div>
    )
}

export default ProgramasDIF